import React, { useEffect, useState } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { Spinner } from '../../components/ui/Spinner';
import { verifyInvite } from '../../modules/platform/api/auth';
import { showErrorToast } from '../../utils/errorHandler';
import { ROUTES } from '../../utils/constants';

export const InviteVerifyPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        await verifyInvite(token);
      } catch (error) {
        showErrorToast(error);
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <Navigate to={`${ROUTES.INVITE_ACCEPT}?token=${token}`} replace />;
};

